import { render, staticRenderFns } from "./list-host.vue?vue&type=template&id=2d3b3e61"
import script from "./list-host.vue?vue&type=script&lang=js"
export * from "./list-host.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports